import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import Footer from "../../components/footer/Footer";
import IconCard1 from "../../images/icon_card_14.png";
import IconCard2 from "../../images/icon_card_16.png";
import IconCard3 from "../../images/icon_card_17.png";
import IconCard4 from "../../images/icon_card_6.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS8 = () => {
  const solutions = [
    {
      title: "Struggling with Low Online Visibility & Lead Generation?",
      problem:
        "Limited digital presence, ineffective marketing strategies, and lack of technical awareness.",
      solution:
        "We provide SEO-optimized websites, localized PPC advertising, and content marketing to improve visibility and attract more customers.",
    },
    {
      title: "Facing Operational Inefficiencies?",
      problem:
        "Outdated booking systems, manual processes, and lack of automation.",
      solution:
        "We develop custom CRM solutions, AI-powered chatbots, and automated appointment scheduling to streamline business operations.",
    },
    {
      title: "Struggling with Customer Engagement & Retention?",
      problem:
        "Poor user experience, low customer engagement, and ineffective communication channels.",
      solution:
        "Our responsive website designs, mobile-friendly applications, and personalized email/SMS marketing enhance customer interaction & loyalty.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "Custom business websites with engaging UX/UI",
        "Online booking and scheduling systems",
        "E-commerce solutions for home service businesses",
        "AI-powered chatbots for customer support",
        "Data-driven dashboards for performance tracking",
      ],
      image: require("../../images/web-development-6.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "Local SEO & Google My Business optimization",
        "PPC advertising for lead generation",
        "Email & SMS marketing automation",
        "Social media branding & paid campaigns",
        "Online reputation management & customer reviews",
      ],
      image: require("../../images/digital-marketing-6.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    { title: "Cloud Migration & Infrastructure Analytics", icon: IconCard1 },
    {
      title: "Cybersecurity Monitoring & Compliance Reportst",
      icon: IconCard2,
    },
    { title: "IT SaaS Platform UI/UX Mockups", icon: IconCard3 },
    { title: "Automated AI-Powered IT Solutions", icon: IconCard4 },
  ];

  const caseStudyData = {
    sectionTitle: "Success Stories Across Multiple Industries",
    sectionSubtitle:
      "Our SEO-driven home service website boosted inquiries by 85% within 4 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Elevate Your Business",
    description: "Transform Operations, Engage Customers & Scale Faster.",
    buttonText: "Lets Talk for more",
    image: require("../../images/bakery.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay ahead with insights on home service trends and digital transformation.";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Empowering Local Businesses with Digital Transformation"}
          pageSub={
            "Scalable, efficient, and customer-driven solutions to enhance operations, boost online presence, and drive business growth."
          }
          backgroundImage={require("../../images/web-9.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Visualizing the Future of Home Services & Beyond"}
          subTiltle={"Partnering with us for development means you receive"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          boxAlign="center"
          titleColor="#fff"
          descriptionColor="#fff"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS8;
